export function isValueProvider(provider) {
    return provider.useValue != undefined;
}
